import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import ReminderNotificationData from "./ReminderNotificationData";
import {JobReminderNotificationDataApiDto, NotificationBaseApiDto} from "../../../api/model/rest";
import {getUser} from "../../../store/view/user";
import JobReminderNotificationData from "./JobReminderNotificationData";

/**
 * Reminder notification class.
 */
export default class JobReminderNotification extends NotificationBase {
	/**
	 * @param {string} id Notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read Flag if note is marked as read.
	 * @param {"NOTE_REMINDER"} type Note type, in this case always 'NOTE_REMINDER'.
	 * @param {ReminderNotificationData} data Note notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: JobReminderNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): JobReminderNotification {
		return new JobReminderNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			JobReminderNotificationData.fromJson(json.data as JobReminderNotificationDataApiDto));
	}

	/**
	 * Display user Full name.
	 * @returns {string}
	 */
	displayCreatorName() {
		return getUser(this.data.creator.id).map(u => u.getDisplayName()).getOrElse(this.data.creator.id);
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new JobReminderNotification(id, dateTime, read, type, data);
	}
}
